import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import * as echarts from "echarts";
import {EChartsType} from "echarts/core";
import {onMounted,watch} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'pie',
  props: {
  className: {
    type: String,
    default: 'chart'
  },
  config:{
    type: Object,
    default: ()=>{}
  },
  id: {
    type: String,
    default: 'chart'
  },
  width: {
    type: String,
    default: '200px'
  },
  height: {
    type: String,
    default: '200px'
  },
  chartData:{
    type:Array,
    default:()=>[]
  }
},
  setup(__props) {

let props = __props

let chart:EChartsType;
const initChart =()=> {
  let chart = echarts.init(document.getElementById(props.id))
  let options = {
    // grid: {
    //   top: 10,
    //   left: '2%',
    //   right: '2%',
    //   bottom: '2%',
    //   containLabel: true
    // },
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        type: 'pie',
        radius: ['40%', '80%'],
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: 'inside',
          color:'#fff'
        },
        // roseType: 'area',
        // emphasis: {
        //   label: {
        //     show: true,
        //     fontSize: '40',
        //     fontWeight: 'bold'
        //   }
        // },
        labelLine: {
          show: true
        },
        color:[
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
                offset: 0, color: '#3085e7' // 0% 处的颜色
            }, {
                offset: 1, color: '#86def8' // 100% 处的颜色
            },],
            global: false // 缺省为 false
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
                offset: 0, color: '#ff4d4d' // 0% 处的颜色
            }, {
                offset: 1, color: '#ff7680' // 100% 处的颜色
            },],
            global: false // 缺省为 false
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
                offset: 0, color: '#7c7aef' // 0% 处的颜色
            }, {
                offset: 1, color: '#b7a9f4' // 100% 处的颜色
            },],
            global: false // 缺省为 false
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
                offset: 0, color: '#fd9658' // 0% 处的颜色
            }, {
                offset: 1, color: '#ffe08f' // 100% 处的颜色
            },],
            global: false // 缺省为 false
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
                offset: 0, color: '#f94079' // 0% 处的颜色
            }, {
                offset: 1, color: '#bdffe8' // 100% 处的颜色
            },],
            global: false // 缺省为 false
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
                offset: 0, color: '#00eaff' // 0% 处的颜色
            }, {
                offset: 1, color: '#9efffe' // 100% 处的颜色
            },],
            global: false // 缺省为 false
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
                offset: 0, color: '#410640' // 0% 处的颜色
            }, {
                offset: 1, color: '#ff7680' // 100% 处的颜色
            },],
            global: false // 缺省为 false
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
                offset: 0, color: '#010bff' // 0% 处的颜色
            }, {
                offset: 1, color: '#babeff' // 100% 处的颜色
            },],
            global: false // 缺省为 false
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
                offset: 0, color: '#f8da00' // 0% 处的颜色
            }, {
                offset: 1, color: '#fff4ad' // 100% 处的颜色
            },],
            global: false // 缺省为 false
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
                offset: 0, color: '#ff00fc' // 0% 处的颜色
            }, {
                offset: 1, color: '#ffd0fd' // 100% 处的颜色
            },],
            global: false // 缺省为 false
          },
        ],
        data: props.chartData
      }
    ]
  };
  chart.setOption(options)
  return chart
}
watch(
  ()=>props.chartData,
  (newList,oldList)=>{
    let chart = initChart()
    chart&&chart.resize()
  },
  {deep:true}
)
onMounted(()=>{
  let chart = initChart()
  window.addEventListener('resize',function (){
    chart&&chart.resize()
  })

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: _normalizeClass(__props.className),
    style: _normalizeStyle({height:__props.height,width:__props.width})
  }, null, 14, _hoisted_1))
}
}

})